import { EnvironmentKey } from 'vite-env'

import { environments } from '../../config'
import { Environment, FeatureKey, ServiceKey, SettingKey } from './types'

let currentEnvironment: Environment

export function loadEnvironment(): Promise<Environment> {
    return currentEnvironment
        ? Promise.resolve(currentEnvironment)
        : new Promise((resolve, reject) => {
              loadConfig()
                  .then((config) => {
                      currentEnvironment = config
                      return resolve(currentEnvironment)
                  })
                  .catch(() => {
                      if (import.meta.env.VITE_CLIENT_ENV) {
                          currentEnvironment =
                              environments[import.meta.env.VITE_CLIENT_ENV as EnvironmentKey]
                          return resolve(currentEnvironment)
                      }

                      reject(new Error('No env found: set VITE_CLIENT_ENV in .env.local'))
                  })
          })
}

function loadConfig(): Promise<Environment> {
    return new Promise((resolve, reject) => {
        const fetchConfig = fetch('/config', { method: 'GET' })
        fetchConfig
            .then((response) => {
                return response.json()
            })
            .then((config) => {
                return resolve(config)
            })
            .catch(() => {
                return reject(new Error('could not load /config'))
            })
    })
}

export function hasFeature(featureKey: FeatureKey): boolean {
    if (!currentEnvironment) new Error('environment not loaded')
    return currentEnvironment.features[featureKey] === true
}

export function hasService(serviceKey: ServiceKey): boolean {
    if (!currentEnvironment) return false
    const endpoint = currentEnvironment.endpoints[serviceKey]
    return typeof endpoint === 'string' && endpoint.length > 0
}

export function getEnvironment(): Environment {
    if (!currentEnvironment) new Error('environment not loaded')
    return currentEnvironment
}

export const wrappService = (serviceKey: ServiceKey) => {
    if (!currentEnvironment) new Error('Environment not loaded')
    return (uri = '') => {
        return `${currentEnvironment['endpoints'][serviceKey]}${uri}`
    }
}

export const urlWrapper = (serviceKey: ServiceKey) => (url: string) => () =>
    wrappService(serviceKey)(url)

export const services = {
    assets: wrappService('assets'),
    calculation: wrappService('calculation'),
    concept: wrappService('concept'),
    contact: wrappService('contact'),
    distribution: wrappService('distribution'),
    identity: wrappService('identity'),
    identityserver: wrappService('identityserver'),
    metadata: wrappService('metadata'),
    profitability: wrappService('profitability'),
    royalty: wrappService('royalty'),
    schilling: wrappService('schilling'),
    storage: wrappService('storage'),
    users: wrappService('users'),
    work: wrappService('work'),
}

export const servicesLoaders = {
    assets: urlWrapper('assets'),
    calculation: urlWrapper('calculation'),
    concept: urlWrapper('concept'),
    contact: urlWrapper('contact'),
    distribution: wrappService('distribution'),
    identity: urlWrapper('identity'),
    identityserver: urlWrapper('identityserver'),
    metadata: urlWrapper('metadata'),
    profitability: wrappService('profitability'),
    royalty: wrappService('royalty'),
    schilling: wrappService('schilling'),
    users: urlWrapper('users'),
    work: urlWrapper('work'),
}

export const getSetting = (settingKey: SettingKey) => {
    if (!currentEnvironment) new Error('environment not loaded')
    return currentEnvironment['settings'][settingKey]
}

export const getLabel = (inputKey: string) => {
    if (!currentEnvironment) new Error('environment not loaded')
    if (currentEnvironment['labels'] != undefined) {
        return currentEnvironment['labels'].find((item) => item.key === inputKey)?.value
    } else return null
}
